// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-list {
  padding: 0px;
}
ion-list ion-list-header {
  background-color: #f9f9f9;
  color: #727272;
}
ion-list ion-item {
  --padding-start: 0px !important;
  --inner-padding-end: 0px !important;
  --border-color: #dedede !important;
}
ion-list ion-row {
  width: 100%;
}
ion-list .left-content {
  color: #666565 !important;
  font-size: 14px !important;
  padding-left: 15px;
}
ion-list .right-content {
  text-align: center;
  padding: 0;
  margin-top: auto;
}
ion-list .right-content ion-icon {
  font-size: 19px;
  color: #727272 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/filter-list/filter-list.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AAAE;EACE,yBAAA;EACA,cAAA;AAEJ;AAAE;EACE,+BAAA;EACA,mCAAA;EACA,kCAAA;AAEJ;AAAE;EACE,WAAA;AAEJ;AAAE;EACE,yBAAA;EACA,0BAAA;EACA,kBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;AAEJ;AADI;EACE,eAAA;EACA,yBAAA;AAGN","sourcesContent":["ion-list {\n  padding: 0px;\n  ion-list-header {\n    background-color: #f9f9f9;\n    color: #727272;\n  }\n  ion-item {\n    --padding-start: 0px !important;\n    --inner-padding-end: 0px !important;\n    --border-color: #dedede !important;\n  }\n  ion-row {\n    width: 100%;\n  }\n  .left-content {\n    color: #666565 !important;\n    font-size: 14px !important;\n    padding-left: 15px;\n  }\n  .right-content {\n    text-align: center;\n    padding: 0;\n    margin-top: auto;\n    ion-icon {\n      font-size: 19px;\n      color: #727272 !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
